import React, { useCallback, useEffect, useState } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { getCategoriasProduto, products } from '../../slices/productSlice';
import { getCategoria } from '../../slices/getCategoria';
import Main from '../../components/Main/Main';
import Title from '../../components/Title';
import InputSearch from '../../components/Search/InputSearch';
import { Outlet } from 'react-router-dom';
import TableMui from '../../components/Table/TableMui';
import { resetProduct } from '../../slices/productSlice';
import usePageTitle from '../../hook/usePageTitle';
import { IconButton } from '@material-tailwind/react';
import { Download } from 'lucide-react';
import { useExportExcel } from '../../hook/useExportExcel';

const Produtos = () => {
  usePageTitle();
  const dispatch = useDispatch();
  const { productos, categorias, loading } = useSelector((state) => state.product);
  const [inputSearch, setInputSeacrh] = useState('');
  const [filterCategoria, setFilterCategoria] = useState('');

  const dadosFiltrado = productos.filter((produto) => {
    const search = inputSearch.toLowerCase();
    const categoria = filterCategoria ? produto.categoria.nome === filterCategoria : true;
    const filtro =
      produto.nome.toLowerCase().includes(search) ||
      produto.descricao.toLowerCase().includes(search) ||
      produto.winthor.includes(search);
    return filtro && categoria;
  });

  const handleBuscaChange = useCallback((e) => {
    setInputSeacrh(e.target.value);
  }, []);
  const handleCategoriaChange = useCallback((val) => {
    setFilterCategoria(val);
  }, []);

  useEffect(() => {
    if (productos) {
      dispatch(getCategoria());
      dispatch(getCategoriasProduto());
    }
    return () => dispatch(resetProduct());
  }, [dispatch]);

  const columns = [
    { id: 'nome', label: 'Produto', width: '80%' },
    { id: 'quantidade_total', label: 'QTD', width: 130 },
    { id: 'endereco', label: ' Endereço', width: 130 },
    { id: 'winthor', label: 'Codigo', width: 130 },
  ];

  return (
    <Main>
      <div className="sm:flex mt-0">
        <Title>Produtos</Title>
        <InputSearch
          array={categorias}
          search={handleBuscaChange}
          setFilterCategoria={handleCategoriaChange}
          value={filterCategoria}
        />
        <IconButton
          color="white"
          className="mt-2 hidden sm:block"
          onClick={() => useExportExcel(dadosFiltrado, 'Produtos')}
        >
          <Download />
        </IconButton>
      </div>
      <Outlet />
      <div className="h-[90%]  mt-6  w-full mx-auto">
        <TableMui columns={columns} rows={dadosFiltrado} search={inputSearch} loading={loading} />
      </div>
    </Main>
  );
};

export default Produtos;
